import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import LegalReviewContent from './shared/LegalReviewContent';

const TermsOfUsePopup = ({
  show,
  onAccept,
  onDecline,
  loading,
  allowDecline = true,
  showPrivacyToggle = true,
  acceptLabel = 'I Accept the Terms'
}) => {
  const [termsState, setTermsState] = useState({
    canAccept: false,
    loading: false,
    termsId: null,
  });

  const handleAccept = () => {
    if (termsState.termsId) {
      onAccept(termsState.termsId);
    }
  };

  return (
    <Modal
      show={show}
      onHide={allowDecline ? onDecline : undefined}
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton={allowDecline}>
        <Modal.Title>Review GrabTime policies</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <LegalReviewContent
          showPrivacyToggle={showPrivacyToggle}
          onStateChange={setTermsState}
        />
      </Modal.Body>

      <Modal.Footer>
        {allowDecline && (
          <Button
            variant="secondary"
            onClick={onDecline}
            disabled={loading}
          >
            Decline
          </Button>
        )}
        <Button
          variant="primary"
          onClick={handleAccept}
          disabled={loading || !termsState.canAccept}
          style={{
            backgroundColor: '#4A9B8F',
            borderColor: '#4A9B8F'
          }}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Processing...
            </>
          ) : (
            acceptLabel
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsOfUsePopup;
